module.exports = __webpack_public_path__ + "static/media/immoquipo-logo.ec1eba2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/immoquipo-logo.png
// module id = 279
// module chunks = 0